module.exports = __webpack_public_path__ + "img/antoniacanales.9e853648.jpg";